import module from 'guest/module.js'
import template from './template.html'

class GuestComponent {
  constructor () {
    this.idEmpresa = null
    this.idEmpleado = null
    this.data = null
    this.catalogos = null
  }

  $onInit () {
    this.uid = `${this.idEmpleado}@${this.idEmpresa}`
  }
}

module.component('guest', {
  controller: GuestComponent,
  template,
  bindings: {
    idEmpresa: '<',
    idEmpleado: '<',
    data: '<',
    catalogos: '<',
  },
})



// WEBPACK FOOTER //
// ./src/guest/components/component.js